import {set, get} from 'tiny-cookie'

Number.isInteger = Number.isInteger || function (value) {
	return typeof value === 'number' &&
		isFinite(value) &&
		Math.floor(value) === value;
};


const VueCookie = {

	install: function (Vue) {
		Vue.config.globalProperties.$cookie = this;
		Vue.cookie = this;
	},
	set: function (name, value, daysOrOptions) {
		var opts = daysOrOptions;
		if(Number.isInteger(daysOrOptions)) {
			opts = {expires: daysOrOptions};
		}
		return set(name, value, opts);
	},

	get: function (name) {
		return get(name);
	},

	delete: function (name, options) {
		var opts = {expires: -1};
		if(options !== undefined) {
			opts = Object.assign(options, opts);
		}
		this.set(name, '', opts);
	}
};

export default VueCookie